import React, { useState, useEffect } from 'react';
import { Package, RefreshCw } from 'lucide-react';

const UpdatesTab = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUpdates = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/software-updates');
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      const data = await res.json();
      setUpdates(data.updates || []);
      setError(null);
    } catch (e) {
      setError(e.message || 'Failed to load update history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUpdates(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h2 style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '26px' }}>
          <Package size={26} style={{ color: '#f59e0b' }} />
          Software Updates
        </h2>
        <button
          onClick={fetchUpdates}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.4)', borderRadius: '8px', color: '#3b82f6', cursor: 'pointer' }}
        >
          <RefreshCw size={16} /> Refresh
        </button>
      </div>

      {error && <div style={{ color: '#ef4444', marginBottom: '16px' }}>Error: {error}</div>}
      {loading ? (
        <p style={{ color: '#94a3b8' }}>Loading...</p>
      ) : updates.length === 0 ? (
        <p style={{ color: '#94a3b8' }}>No updates recorded yet.</p>
      ) : (
        <div style={{ background: 'rgba(15,23,42,0.8)', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(59,130,246,0.2)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'rgba(59,130,246,0.15)', color: '#94a3b8', textAlign: 'left' }}>
                <th style={{ padding: '12px 16px' }}>Applied</th>
                <th style={{ padding: '12px 16px' }}>Server</th>
                <th style={{ padding: '12px 16px' }}>Package</th>
                <th style={{ padding: '12px 16px' }}>From → To</th>
                <th style={{ padding: '12px 16px' }}>Security</th>
              </tr>
            </thead>
            <tbody>
              {updates.map((u) => (
                <tr key={u._id} style={{ borderTop: '1px solid rgba(59,130,246,0.1)' }}>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0', whiteSpace: 'nowrap' }}>{new Date(u.appliedAt).toLocaleString()}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{u.server}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{u.package}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0', fontFamily: 'monospace', fontSize: '12px' }}>
                    {u.fromVersion || '—'} → {u.toVersion || '—'}
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    {u.securityRelevant ? (
                      <span style={{ padding: '2px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600, background: 'rgba(239,68,68,0.2)', color: '#ef4444' }}>
                        SECURITY
                      </span>
                    ) : (
                      <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UpdatesTab;
